import React, { useEffect } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import appIcon from '../../assets/landing/app-icon.png';
import { useAppSelector } from '../../redux/store';
import { useLogoutMutation } from '../../redux/auth/auth.api';
import { EnvSwitcher } from '../../components/EnvSwitcher';
import '../../styles/landing.css';

const ADMIN_ROLE = 3;

const TABS: Array<{ to: string; label: string }> = [
  { to: 'users', label: 'Users' },
  { to: 'events', label: 'Events' },
  { to: 'candidates', label: 'Candidates' },
  { to: 'clubs', label: 'Clubs' },
  { to: 'covers', label: 'Covers' },
  { to: 'payouts', label: 'Payouts' },
  { to: 'whats-new', label: "What's New" },
  { to: 'analytics', label: 'Analytics' },
  { to: 'app', label: 'App' },
];

const tabClassName = ({ isActive }: { isActive: boolean }): string =>
  isActive ? 'admin-tab admin-tab--active' : 'admin-tab';

export const AdminDashboard = (): React.JSX.Element => {
  const navigate = useNavigate();
  const admin = useAppSelector((state) => state.auth.admin);
  const [logout] = useLogoutMutation();

  useEffect(() => {
    if (!admin || admin.role !== ADMIN_ROLE) {
      navigate('/admin', { replace: true });
    }
  }, [admin, navigate]);

  if (!admin) return <div className="admin-app" />;

  const signOut = async (): Promise<void> => {
    await logout();
    navigate('/admin', { replace: true });
  };

  const displayName = admin.firstName || admin.email;

  return (
    <div className="admin-app">
      <header className="admin-app__header">
        <div className="admin-app__brand">
          <img src={appIcon} alt="" className="admin-app__brand-icon" />
          <span className="admin-app__brand-name">
            gather <span className="admin-app__brand-tag">admin</span>
          </span>
        </div>
        <div className="admin-app__user">
          <EnvSwitcher />
          <span className="admin-app__user-name">{displayName}</span>
          <button type="button" className="admin-app__signout" onClick={signOut}>
            Sign out
          </button>
        </div>
      </header>
      <nav className="admin-tabs">
        {TABS.map((tab) => (
          <NavLink key={tab.to} to={tab.to} className={tabClassName}>
            {tab.label}
          </NavLink>
        ))}
      </nav>
      <main className="admin-app__content">
        <Outlet />
      </main>
    </div>
  );
};
